/* ══════════════════════════════════════════════════════════════════════
   assets/uc-card-extras.js
   URBAN Care — Ana sayfa kart ekleri: popup (Nasıl kullanılır / Set) ve
   tek tıkla sepete ekleme. Tek bir <dialog> sayfaya bir kez eklenir,
   içerik karttaki <template>'ten kopyalanır.
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.__ucCardExtras) return;
  window.__ucCardExtras = true;

  var dialog = null;
  var lastOpener = null;

  function ensureDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'uc-ce-modal';
    dialog.setAttribute('aria-label', 'Ürün detayı');
    dialog.innerHTML =
      '<div class="uc-ce-modal__panel">' +
        '<button type="button" class="uc-ce-modal__close" data-ce-close aria-label="Kapat">' +
          '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
        '</button>' +
        '<div class="uc-ce-modal__body"></div>' +
      '</div>';
    document.body.appendChild(dialog);

    dialog.addEventListener('click', function (evt) {
      if (evt.target === dialog || evt.target.closest('[data-ce-close]')) closeDialog();
    });
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('uc-ce-lock');
      if (lastOpener && document.contains(lastOpener)) lastOpener.focus();
    });
    return dialog;
  }

  function openPopup(id, opener) {
    var tpl = document.getElementById('uc-ce-' + id);
    if (!tpl) return;
    var d = ensureDialog();
    var body = d.querySelector('.uc-ce-modal__body');
    body.innerHTML = '';
    body.appendChild(tpl.content.cloneNode(true));
    body.scrollTop = 0;
    if (!d.open) {
      lastOpener = opener || null;
      if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
      document.documentElement.classList.add('uc-ce-lock');
    }
    var title = body.querySelector('.uc-ce-pop__title');
    if (title) d.setAttribute('aria-label', title.textContent.trim());
  }

  function closeDialog() {
    if (!dialog || !dialog.open) return;
    if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
  }

  function addToCart(btn) {
    if (btn.disabled) return;
    var label = btn.querySelector('span') || btn;
    var original = label.textContent;
    btn.disabled = true;
    btn.classList.add('is-loading');
    label.textContent = 'Ekleniyor…';

    var addUrl = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
    fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.ceAdd), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) throw new Error(data.description || data.message);
        closeDialog();
        if (document.getElementById('cart-drawer')) {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
        } else {
          window.location.href = (window.theme && theme.routes && theme.routes.cart) || '/cart';
        }
        label.textContent = 'Eklendi ✓';
        setTimeout(function () {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          label.textContent = original;
        }, 1600);
      })
      .catch(function (error) {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        label.textContent = 'Eklenemedi, tekrar dene';
        setTimeout(function () { label.textContent = original; }, 2200);
        console.warn('[uc-card-extras]', error); // eslint-disable-line
      });
  }

  document.addEventListener('click', function (evt) {
    var opener = evt.target.closest('[data-ce-open]');
    if (opener) {
      evt.preventDefault();
      evt.stopPropagation();
      openPopup(opener.dataset.ceOpen, opener.closest('.uc-ce-modal') ? lastOpener : opener);
      return;
    }
    var adder = evt.target.closest('[data-ce-add]');
    if (adder) {
      evt.preventDefault();
      evt.stopPropagation();
      addToCart(adder);
    }
  });
})();
